import React from 'react';

const StarIcon = ({ filled, size = 24 }: { filled: boolean; size?: number }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={filled ? 'gold' : 'none'}
        stroke={filled ? 'gold' : '#ddd'}
        strokeWidth="1.5"
    >
        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
    </svg>
);

const StarRating = ({ rating }: { rating: number }) => (
    <div style={{ display: 'flex', gap: '2px' }}>
        {[1, 2, 3, 4, 5].map((star) => (
            <StarIcon key={star} filled={star <= rating} />
        ))}
    </div>
);

export default StarRating;